import { createNotification } from "react-redux-notify";
import { all, put, select, takeEvery, takeLatest } from "redux-saga/effects";
import { getErrorNotificationMessage, getSuccessNotificationMessage } from "../../components/helper/NotificationMessage";
import {
  DELETE_ALL_USER_SHOWCASE_START,
  DELETE_USER_SHOWCASE_START,
  FETCH_USER_SHOWCASE_START,
  FETCH_USER_SHOWCASE_START_ID,
  UPLOAD_USER_SHOWCASE_START,
  UPDATE_SHOWCASE_VISIBILITY,
  REQUEST_VISIBILITY_SHOWCASE,
  APPROVED_VISIBILITY_SHOWCASE,
  DECLINE_VISIBILITY_SHOWCASE
} from "../actions/ActionConstant";
import { hideErrorComponent, showErrorComponent } from "../actions/ComponentAction";
import { parseContentServiceError } from "../../helpers/services/content/error";
import showcaseService from "../../helpers/services/content/showcase.service";
import {
  deleteAllUserShowcaseSuccess,
  deleteUserShowcaseFailure,
  deleteUserShowcaseSuccess,
  fetchUserShowcaseFailure,
  fetchUserShowcaseFailureById,
  fetchUserShowcaseSuccess,
  fetchUserShowcaseSuccessById,
  uploadShowcaseMediaFailure,
  uploadShowcaseMediaSuccess,
  updateShowcaseVisibilityFailure,
  updateShowcaseVisibilitySuccess,
  requestVisibilityShowcaseSuccess,
  requestVisibilityShowcaseFailure,
  approvedVisibilityShowcaseSuccess,
  approvedVisibilityShowcaseFailure,
  visibilityDeclineShowcaseSuccess,
  visibilityDeclineShowcaseFailure
} from "../actions/ShowcaseAction";
import { fetchNotificationsStart } from "../actions/NotificationAction";

function* addShowCaseMedia(action) {
  try {
    const inputData = yield select((state) => state.showCase.showcase.inputData);
    const { onUploadProgress, close, ...payload } = inputData
    if (!inputData.files || inputData.files.length === 0) {
      yield put(uploadShowcaseMediaFailure("Please add files!"));
      const notificationMessage = getErrorNotificationMessage("Please add files!");
      yield put(createNotification(notificationMessage));
      return;
    }
    const response = yield showcaseService.createShowcase(payload, {
      onUploadProgress: (event) => {
        let progress = (event.loaded / event.total) * 100;
        onUploadProgress(Math.ceil(progress));
      }

    });

    yield put(uploadShowcaseMediaSuccess(response));
    const notificationMessage = getSuccessNotificationMessage(
      "Showcase uploaded successfully!"
    );
    yield put(createNotification(notificationMessage));
    yield put(hideErrorComponent());
    close();
  } catch (error) {

    yield put(uploadShowcaseMediaFailure(error));
    if (error?.response?.status !== 400) {
      yield put(showErrorComponent({ error: error, status: error?.response?.status ? error?.response?.status : 500 }));
    }
    const notificationMessage = getErrorNotificationMessage(parseContentServiceError(error.response));
    yield put(createNotification(notificationMessage));
  }
}
function* fetchShowcase(action) {
  try {
    const response = yield showcaseService.getShowcase();
    if (response.length > 0) {
      yield put(fetchUserShowcaseSuccess(response));
    } else {
      yield put(fetchUserShowcaseFailure(response));
    }
    yield put(hideErrorComponent());
  } catch (error) {
    yield put(fetchUserShowcaseFailure(error));
  }
}
//Fetch user showcase By id
function* fetchShowcaseByUserID(action) {
  try {
    const response = yield showcaseService.getShowcaseByUserId(action.payload);
    if (response.length > 0) {
      yield put(fetchUserShowcaseSuccessById(response));
    } else {
      yield put(fetchUserShowcaseFailureById(response));
    }
    yield put(hideErrorComponent());
  } catch (error) {
    yield put(fetchUserShowcaseFailure(error));
  }
}

function* updateShowcaseVisibilityAPI(action) {
  try {
    const response = yield showcaseService.visibilityShowcase(action.params, action.data);
    if (response.status) {
      yield put(updateShowcaseVisibilitySuccess(response));
      const notificationMessage = getSuccessNotificationMessage("Showcase visibility updated successfully");
      yield put(createNotification(notificationMessage));
      yield put(hideErrorComponent());
    } else {
      yield put(updateShowcaseVisibilityFailure(response.data.error));
      const notificationMessage = getErrorNotificationMessage(response.data.error);
      yield put(createNotification(notificationMessage));
    }
  } catch (error) {
    yield put(updateShowcaseVisibilityFailure(error));
    const notificationMessage = getErrorNotificationMessage(error.message);
    yield put(createNotification(notificationMessage));
  }
}

function* requestVisibilityShowcaseAPI(action) {
  try {
    const response = yield showcaseService.visibilityRequestShowcase(action.payload);
    if (response) {
      yield put(requestVisibilityShowcaseSuccess(response));
      const notificationMessage = getSuccessNotificationMessage("Request send successfully");
      yield put(createNotification(notificationMessage));
      yield put(hideErrorComponent());
    } else {
      yield put(requestVisibilityShowcaseFailure(response.error));
      const notificationMessage = getErrorNotificationMessage(response.error);
      yield put(createNotification(notificationMessage));
    }
  } catch (error) {
    const errorMessage = error?.response?.data?.error || error.message;
    yield put(requestVisibilityShowcaseFailure(error));
    const notificationMessage = getErrorNotificationMessage(errorMessage);
    yield put(createNotification(notificationMessage));
  }
}

function* approvedVisibilityShowcaseAPI(action) {
  try {
    const response = yield showcaseService.visibilityApprovedShowcase(action.payload);
    if (response.status) {
      yield put(approvedVisibilityShowcaseSuccess(response));
      const notificationMessage = getSuccessNotificationMessage("Request approved successfully");
      yield put(createNotification(notificationMessage));
      yield put(hideErrorComponent());
      yield put(fetchNotificationsStart());
    } else {
      yield put(approvedVisibilityShowcaseFailure(response.error));
      const notificationMessage = getErrorNotificationMessage(response.error);
      yield put(createNotification(notificationMessage));
    }
  } catch (error) {
    const errorMessage = error?.response?.data?.error || error.message;
    yield put(approvedVisibilityShowcaseFailure(error));
    const notificationMessage = getErrorNotificationMessage(errorMessage);
    yield put(createNotification(notificationMessage));
  }
}

function* visibilityDeclineShowcaseAPI(action) {
  try {
    const response = yield showcaseService.visibilityDeclineShowcase(action.payload);
    if (response.status) {
      yield put(visibilityDeclineShowcaseSuccess(response));
      const notificationMessage = getSuccessNotificationMessage("Request declined successfully");
      yield put(createNotification(notificationMessage));
      yield put(hideErrorComponent());
      yield put(fetchNotificationsStart());
    } else {
      yield put(visibilityDeclineShowcaseFailure(response.error));
      const notificationMessage = getErrorNotificationMessage(response.error);
      yield put(createNotification(notificationMessage));
    }
  } catch (error) {
    const errorMessage = error?.response?.data?.error || error.message;
    yield put(visibilityDeclineShowcaseFailure(error));
    const notificationMessage = getErrorNotificationMessage(errorMessage);
    yield put(createNotification(notificationMessage));
  }
}

function* deleteShowcaseAPI(action) {
  try {
    const response = yield showcaseService.deleteShowcase(action.payload);
    if (response.success) {
      yield put(deleteUserShowcaseSuccess(action.payload));
      const notificationMessage = getSuccessNotificationMessage(
        response.message
      );

      yield put(createNotification(notificationMessage));
      yield put(hideErrorComponent());
    } else {
      yield put(deleteUserShowcaseFailure(response.data.error));
      const notificationMessage = getErrorNotificationMessage(
        response.data.error
      );
      yield put(createNotification(notificationMessage));
    }
  } catch (error) {
    yield put(deleteUserShowcaseFailure(error));
    const notificationMessage = getErrorNotificationMessage(error.message);
    yield put(createNotification(notificationMessage));
  }
}
function* deleteAllShowcase() {
  try {

    const response = yield showcaseService.deleteAllShowcase();
    if (response.success) {
      yield put(deleteAllUserShowcaseSuccess());
      const notificationMessage = getSuccessNotificationMessage(
        response.message
      );
      yield put(createNotification(notificationMessage));
      yield put(hideErrorComponent());

    } else {
      yield put(deleteUserShowcaseFailure(response.data.error));
      const notificationMessage = getErrorNotificationMessage(
        response.data.error
      );
      yield put(createNotification(notificationMessage));
    }
  } catch (error) {
    yield put(deleteUserShowcaseFailure(error));
    const notificationMessage = getErrorNotificationMessage(error.message);
    yield put(createNotification(notificationMessage));
  }
}



export default function* pageSaga() {
  yield all([
    takeLatest(UPLOAD_USER_SHOWCASE_START, addShowCaseMedia),
    takeLatest(FETCH_USER_SHOWCASE_START, fetchShowcase),
    takeLatest(FETCH_USER_SHOWCASE_START_ID, fetchShowcaseByUserID),
    takeLatest(DELETE_USER_SHOWCASE_START, deleteShowcaseAPI),
    takeLatest(DELETE_ALL_USER_SHOWCASE_START, deleteAllShowcase),
    takeLatest(UPDATE_SHOWCASE_VISIBILITY, updateShowcaseVisibilityAPI),
    takeLatest(REQUEST_VISIBILITY_SHOWCASE, requestVisibilityShowcaseAPI),
    takeLatest(APPROVED_VISIBILITY_SHOWCASE, approvedVisibilityShowcaseAPI),
    takeLatest(DECLINE_VISIBILITY_SHOWCASE, visibilityDeclineShowcaseAPI)

  ]);
}
